import type React from 'react'
import {Button as PepsiCoButton} from 'pepsico-ds'
import type {IButtonProps} from 'pepsico-ds'

const ButtonWrapper: React.FC<IButtonProps> = ({className = '', type = 'button', ...rest}) => {
  return <PepsiCoButton className={className} type={type} {...rest} />
}

export default ButtonWrapper
